import {PlayerIndicator} from '../views/components/playerIndicator/playerIndicator';
import {toMMSS} from '../utils/math/time';

export class AudioPlayer {
  public element: HTMLElement;
  public isPlaying: boolean;
  private playerIndicator: PlayerIndicator;
  private audioElement: HTMLAudioElement;
  private progressText: HTMLElement;
  private durationText: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
    this.audioElement = element.querySelector('audio');
    this.progressText = element.querySelector('.progress');
    this.durationText = element.querySelector('.duration');

    this.playerIndicator = new PlayerIndicator(this.element.querySelector('.playerIndicatorWrapper'));
    this.playerIndicator.element.addEventListener('click', this.playToggleHandler.bind(this));
    this.audioElement.addEventListener('timeupdate', this.onPlayHandler);
  }

  private playToggleHandler(e) {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.playerIndicator.showPause();
      this.audioElement.play();
    } else {
      this.playerIndicator.showPlay();
      this.audioElement.pause();
    }
  }

  private onPlayHandler = () => {
    this.playerIndicator.setProgress((this.audioElement.currentTime / this.audioElement.duration) * 100);
    if (this.audioElement.currentTime) {
      this.progressText.innerHTML = toMMSS(this.audioElement.currentTime);
    }
    if (this.audioElement.duration) {
      this.durationText.innerHTML = toMMSS(this.audioElement.duration);
    }
  };

  public kill() {
    this.audioElement.removeEventListener('timeupdate', this.onPlayHandler);
  }
}
